import "./init";
import "./utils/devtools/useWhatChanged.ts";
//  Must be loaded first
import { init as initSaola } from "@saola.ai/browser";
import App from "components/App";
import { compiledClientConfig } from "config";
import { createElement } from "react";
import { createRoot } from "react-dom/client";

import "./i18n";
import "./index.css";

if (compiledClientConfig.saolaAccountToken) {
  initSaola(compiledClientConfig.saolaAccountToken);
}
const rootElement = document.getElementById("app");
createRoot(rootElement!).render(createElement(App));
